import React, { useState, useEffect } from "react";
import VisaOfficesSection from "./VisaOfficesSection.jsx";
import EmbassiesSection from "./EmbassiesSection.jsx";
import FormsSection from "./FormsSection.jsx";
import ResourcesSection from "./ResourcesSection.jsx";
import "./styles.css";

/* ================================================================
   HERO SECTION — centered layout
   ================================================================ */
function HeroSection() {
  return (
    <section className="VF-hero" id="home" aria-label="Hero">
      <div className="VF-container">
        <div className="VF-hero__inner">
          <div className="VF-hero__content" data-aos="fade-up" data-aos-duration="700">
           <h1 className="VF-hero__title">
              Your Complete Guide 
            </h1>
            {/* to <em>Visa Services</em>  */}
            <p className="VF-hero__subtitle">
              Explore visa offices, embassies, and consulates across India.
            </p>
            

            {/* Quick scroll anchor links */}
            {/* <div className="VF-hero__scroll-links" data-aos="fade-up" data-aos-delay="200">
              <a href="#visa-offices" className="VF-hero__scroll-link">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                Offices
              </a>
              <a href="#embassies" className="VF-hero__scroll-link">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
                </svg>
                Embassies
              </a>
              <a href="#visa-forms" className="VF-hero__scroll-link">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
                Forms
              </a>
              <a href="#resources" className="VF-hero__scroll-link">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                </svg>
                Resources
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ================================================================
   SCROLL TO TOP
   ================================================================ */
function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      className={`VF-scroll-top${visible ? " VF-scroll-top--visible" : ""}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  );
}

/* ================================================================
   SLIM FOOTER
   ================================================================ */
function Footer() {
  return (
    <footer className="VF-footer" role="contentinfo">
      <div className="VF-container">
        <div className="VF-footer__bottom">
          <p className="VF-footer__copy">
            &copy; {new Date().getFullYear()} Visa Form — India Visa Directory. All rights reserved.
          </p>
          <p className="VF-footer__disclaimer">
            For informational purposes only. Always verify details with official government portals before making any visa-related decisions.
          </p>
        </div>
      </div>
    </footer>
  );
}

/* ================================================================
   ROOT APP
   ================================================================ */
export default function App() {
  const [activeTab, setActiveTab] = useState("visaOffices");

  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({ duration: 650, easing: "ease-out-cubic", once: true, offset: 60 });
    }
  }, []);

  const TAB_ITEMS = [
    { id: "visaOffices", label: "Visa Offices & FRROs" },
    { id: "embassies", label: "Embassies & Consulates" },
    { id: "visaForms", label: "Visa Form" },
  ];

  return (
    <>
      <a href="#main-content" className="VF-skip-link">Skip to main content</a>
      <main id="main-content">
        <HeroSection />
        <section className="VF-section VF-tab-bar-wrapper" style={{ padding: "0 0 30px" }}>
          <div className="VF-container">
            <div className="VF-tab-bar" role="tablist">
              {TAB_ITEMS.map((tab) => (
                <button
                  key={tab.id}
                  role="tab"
                  aria-selected={activeTab === tab.id}
                  className={`VF-tab-btn ${activeTab === tab.id ? "VF-tab-btn--active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </section>
        <div style={{ display: activeTab === "visaOffices" ? "block" : "none" }}>
          <VisaOfficesSection />
        </div>
        <div style={{ display: activeTab === "embassies" ? "block" : "none" }}>
          <EmbassiesSection />
        </div>
        <div style={{ display: activeTab === "visaForms" ? "block" : "none" }}>
          <FormsSection />
        </div>
        <ResourcesSection />
      </main>
    </>
  );
}